export const iconFontAwesomeTravelHotelPlane = (
	<i className="fa-solid fa-plane"></i>
);
